import React, { Fragment } from 'react'
import {
    OverContainerSection,
    OverContainer,
    OverSection,
    TitleTypography,
    SectionCard,
} from './styles'
import { BuildProjectLabels } from 'src/constants'
import { MapSection } from './mapSection'
import { MapCard } from './mapCard'
import { Destok, Mobil, Refer } from './styles'
import { useTranslations } from 'src/provider/LocaleProvider'

export const GrowthProject = () => {
    const t = useTranslations()
    const { BuildProject } = BuildProjectLabels()
    return (
        <Fragment>
            <OverContainerSection id={'blog'}>
                <OverSection
                    marginTop={['xlarge', 'xlarge', 'xlarge', 'xxspacesFull']}
                >
                    <TitleTypography
                        variant={'h1'}
                        fontSize={[
                            'xxxsmall',
                            'xxxsmall',
                            'xmedium',
                            'xxxmedium',
                        ]}
                        fontWeight={500}
                    >
                        {t('buildProject.titleSection')}
                    </TitleTypography>
                    <SectionCard
                        marginTop={['xlarge', 'xlarge', 'xxmedium', 'large']}
                    >
                        {BuildProject.map((Card) => (
                            <MapCard key={Card.id} {...Card} />
                        ))}
                    </SectionCard>
                </OverSection>
                <OverContainer
                    marginTop={['xlarge', 'xlarge', 'xxmedium', 'xsixty']}
                >
                    {BuildProject.map((Build) => {
                        return (
                            <Refer key={Build.id} id={Build.linkId}>
                                <Mobil>
                                    <MapSection data={Build} value={false} />
                                </Mobil>
                                <Destok>
                                    <MapSection data={Build} value={true} />
                                </Destok>
                            </Refer>
                        )
                    })}
                </OverContainer>
            </OverContainerSection>
        </Fragment>
    )
}
